//Main
import vuex from "vuex"
import vue from "vue"
import vapi from "vuex-rest-api"
import store from "./index.js"
vue.use(vuex);


//store
const avancecuantitativo = new vapi({
    baseURL: `${process.env.VUE_APP_REST}/api`,
    state: {
        Aavancecuantitativo: [],
        Aavancecuantitativohistoric: [],
        Aindicadoravance:[]
    }
}).get({
    action: "getavancecuantitativo",   
    path: function (obj) {
        return `avancecuantitativo/${obj.idindicador}`;
    }, 
    onSuccess: (state, payload ) => {
        state.Aavancecuantitativo = payload.data;
    },
    onError: (state, error) => {           
        store.dispatch("mensaje/set_error", error);   
    }
}).get({
    action: "getcuantitativohistorico",   
    path: function (obj) {
        return `avancecuantitativo/historial/${obj.idindicador}`;
    }, 
    onSuccess: (state, payload ) => {
        state.Aavancecuantitativohistoric = payload.data;
    },
    onError: (state, error) => {        
        store.dispatch("mensaje/set_error", error);   
    }
}).get({
    action: "Indicador_avances",
    path: function (obj) {
        return `indicador/avanceencabezado/${obj.idindicador}`
    },
    onSuccess: (state, payload) => {
        state.Aindicadoravance = payload.data;
    }
}).put({
    action: "putavance", 
    path: function () {      
        return `avancecuantitativo`},  
    onSuccess: (state, payload ) => {
        store.dispatch("mensaje/set_success", payload); 
    },
    onError: (state, error) => {   
        state.Aindicadoravance.finalizar = false;
        store.dispatch("mensaje/set_error", error);   
    }
}).put({
    action: "ActualizarCuantitativo",
    path: function (obj) {
        return `avancecuantitativo/guardaravancecuantitativo`
    },
    onSuccess: (state, payload) => {
        store.dispatch("mensaje/set_success", payload);
    },
    onError: (state, error) => {
        store.dispatch("mensaje/set_error", error);
    }
}).delete({
    action: "delete_cuantitativo",
    path: function (obj) {
        return `avancecuantitativo/${obj.idavancecuantitativo}`
    },
    onSuccess: (state, payload) => {
        store.dispatch("mensaje/set_success", payload);
    },
    onError: (state, error) => {
        store.dispatch("mensaje/set_error", error);
    }
}).getStore();

avancecuantitativo.getters = {
    gavancecuantitativo: state => {
        return state.Aavancecuantitativo;
    },
    gavancecuantitativohistoric: state => {
        return state.Aavancecuantitativohistoric;
    },gindicadoravances: state => {
        return state.Aindicadoravance;
    }
}

export default avancecuantitativo;